<div class="events-listing-container">
  <cdk-virtual-scroll-viewport *ngIf="state === 'squash_default'"
                               itemSize="{{typicalItemHeight}}" minBufferPx="300" maxBufferPx="600"
                               class="cdk-scroll">

    <app-event-listing-item *cdkVirtualFor="let listItem of listing.listItems;" [listItem]="listItem"
                      [activeItemCounter]="listing.selectedListItems.length">
    </app-event-listing-item>

    <section *ngIf="!listing.listItems.length;" class="empty-folder" fxLayout="column" fxLayoutAlign="center center"
             style="text-align: center;">
      <span *ngIf="true; else emptyAfterFilter">
        <mat-icon>folder_open</mat-icon>
        <p>No items found.</p>
      </span>
      <ng-template #emptyAfterFilter>
        <mat-icon>search</mat-icon>
        <p>No filter results.</p>
        <p class="secondary">Try another query</p>
      </ng-template>
    </section>
  </cdk-virtual-scroll-viewport>

  <div class="tiles-scroll-container center75" *ngIf="['subscribe_events','cups','classes'].indexOf(state) !== -1">
    <app-tile-listing-item *ngFor="let listItem of listing.listItems; let j = index" [idx]="j" [listItem]="listItem"
                           [activeItemCounter]="listing.selectedListItems.length"
                           [viewState]="'community_class'"
                           [hideEditControl]="true"
                           (clickCourseShares)="clickOnClassShare($event,listItem)"
                           (click)="clickOnClass($event,listItem)">
    </app-tile-listing-item>
    <div *ngIf="listing.listItems.length;" class="clear_both">&nbsp;</div>

    <section *ngIf="!listing.listItems.length;" class="empty-folder" fxLayout="column" fxLayoutAlign="center center"
             style="text-align: center;">
      <span *ngIf="true; else emptyAfterFilter">
        <mat-icon>folder_open</mat-icon>
        <p>No items found.</p>
      </span>
      <ng-template #emptyAfterFilter>
        <mat-icon>search</mat-icon>
        <p>No filter results.</p>
        <p class="secondary">Try another query</p>
      </ng-template>
    </section>
  </div>

  <div *ngIf="state === 'loading'" class="internal-spinner">
    <svg class="spinner" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="2" stroke-miterlimit="10" />
    </svg>
  </div>
  <div *ngIf="state === 'error'" class="internal-spinner">
    >.< Error
  </div>

</div>
